import { useCallback, useRef, useState } from 'react';

/**
 * 한 번에 하나만 — 진행 중인 요청이 끝나기 전에 다시 누르면 무시한다.
 *
 * 왜(2026-10-22 대표 7821 "1초에 여러번 못누르게 해야하지않어?"): 로그인 화면 [인증번호 전송]·[재전송]이
 * 가입 여부 확인·문자 요청을 기다리는 동안 잠기지 않아, 같은 사람이 1초 안에 4번·7번 눌러 문자가 그만큼 나갔다.
 * 화면 상태(useState)만으로 막으면 다시 그리기 전에 들어온 두 번째 누름이 통과하므로, ref로 바로 잠근다.
 * 성공·실패와 상관없이 요청이 끝나면 다시 누를 수 있다(성공 뒤 간격은 각 화면의 재전송 대기 시간이 맡는다).
 */
export function useSingleFlight() {
    const lockRef = useRef(false);
    const [busy, setBusy] = useState(false);

    const run = useCallback(async (task: () => Promise<void>): Promise<void> => {
        if (lockRef.current) return;
        lockRef.current = true;
        setBusy(true);
        try {
            await task();
        } finally {
            lockRef.current = false;
            setBusy(false);
        }
    }, []);

    return { busy, run };
}
